import { FONT_FAMILY } from '@/constants/constants'

export default {
  baseStyle: {
    field: {
      bg: 'bg',
      color: 'fg',
      fontFamily: FONT_FAMILY.default,
      px: '14px',
      py: '6px',
      width: '100%',
      borderColor: 'border',
      borderRadius: '4px',
      borderStyle: 'solid',
      borderWidth: '1px',
      _focus: {
        borderColor: 'primary.focusRing',
        borderWidth: '2px',
      },
      minHeight: '38px',
    },
  },
}
